import React from 'react';

import * as echarts from "echarts";

class LevelChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
             // if (value === 0.875) {
                            //     return '好';
                            // } else if (value === 0.75) {
                            //     return '较好';
                            // } else if (value === 0.5) {
                            //     return '一般';
                            // } else if (value === 0.25) {
                            //     return '较差';
                            // } else if (value === 0.125) {
                            //     return '差';
                            // }
            levelArr:[
                { level: 0.875, text: "高" },
                { level: 0.875, text: "大" },
                { level: 0.875, text: "成长速度快" },
                { level: 0.875, text: "好" },
                { level: 0.75, text: "成长速度较快" },
                { level: 0.75, text: "较高" },
                { level: 0.75, text: "较大" },
                { level: 0.75, text: "较好" },
                { level: 0.5, text: "中等" },
                { level: 0.5, text: "成长缓慢" },
                { level: 0.5, text: "一般" },
                { level: 0.5, text: "不明显" },
                { level: 0.25, text: "较低" },
                { level: 0.25, text: "较小" },
                { level: 0.25, text: "轻度衰退" },
                { level: 0.25, text: "较差" }, 
                { level: 0.25, text: "亏损" }, 
                { level: 0.125, text: "差" },
                { level: 0.125, text: "衰退" },
                { level: 0.125, text: "小" },
                { level: 0.125, text: "严重亏损" },
                { level: 0.125, text: "低" },
                { level: 0, text: "资不抵债" },
                { level: 0, text: "极低" }
              ]
        }

    }

    componentDidMount() {
        this.initCharts()
    }

    // 第三步初始化
    initCharts = () => {
        const _this = this
        const { levelArr } = this.state
        let value = levelArr.find(item=>{
            return item.text == this.props.value
        })
        let myChart = echarts.init(document.getElementById( this.props.id + "_myChart"));
        let option = {
            series: [
                {
                    type: 'gauge',
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: 1,
                    center: ['50%', '55%'],
                    splitNumber: 8,
                    axisLine: {
                        lineStyle: {
                            width: 6,
                            color: [
                                [0.2, '#d00018'],
                                [0.4, '#d04a25'],
                                [0.6, '#d08837'],
                                [0.8, '#a7d044'],
                                [1, '#15d13e']
                            ]
                        }
                    },
                    axisTick: {
                        length: 12,
                        lineStyle: {
                            color: 'auto',
                            width: 2
                        }
                    },
                    splitLine: {
                        length: 20,
                        lineStyle: {
                            color: 'auto',
                            width: 5
                        }
                    },
                    axisLabel: {
                        color: '#464646',
                        fontSize: 12,
                        distance: -50,
                        formatter: function (value) {
                            // if (value === 0.875) {
                            //     return '好';
                            // } else if (value === 0.75) {
                            //     return '较好';
                            // } else if (value === 0.5) {
                            //     return '一般';
                            // } else if (value === 0.25) {
                            //     return '较差';
                            // } else if (value === 0.125) {
                            //     return '差';
                            // }
                            return '';
                        }
                    },
                    title: {
                        offsetCenter: [0, '30%'],
                        fontSize: 18
                    },
                    detail: {
                        fontSize: 20,
                        offsetCenter: [0, '60%'],
                        valueAnimation: true,
                        formatter: function (value) {
                            return _this.props.value;
                        },
                        color: 'auto'
                    },
                    data: [
                        {
                            value: value.level,
                            name: this.props.title
                        }
                    ]
                }
            ]
        }

        myChart.setOption(option);
        window.addEventListener("resize", function () {
            myChart.resize();
        });
    }

    render() {
        const { id } = this.props;
        return (
            <div id={id + '_myChart'} style={{ width: "350px", height: "250px" }}>

            </div>
        )
    }
}

export default LevelChart